import { createContext, useContext } from "react";
import globalStore from "./index";
import OrderMarkStore from "./OrderMarkStore";
import OrderSettingStore from "./OrderSettingStore";
import ShippingAreaStore from "./ShippingAreaStore";
import SkuPropertiesFilterStore from "./SkuPropertiesFilterStore";
import CompanySettingStore from "./CompanySettingStore";

export const orderMarkStore = new OrderMarkStore();

export const orderSettingStore = new OrderSettingStore();

export const companySettingStore = new CompanySettingStore(globalStore);

export const orderMarkStoreContext = createContext(orderMarkStore);

export const orderSettingStoreContext = createContext(orderSettingStore);

export const shippingAreaStoreContext = createContext(ShippingAreaStore);

export const skuPropertiesFilterContext = createContext(SkuPropertiesFilterStore);

export const storeContext = createContext(globalStore);

export const companySettingStoreContext = createContext(companySettingStore);

export const useGlobalStore = () => {
    const store = useContext(storeContext);

    return store;
};

export const useOrderMarkStore = () => {
    const store = useContext(orderMarkStoreContext);

    return store;
};

export const useOrderSettingStore = () => {
    const store = useContext(orderSettingStoreContext);

    return store;
};

export const useShippingAreaStore = () => {
    const store = useContext(shippingAreaStoreContext);

    return store;
};

export const useSkuPropertiesFilterStore = () => {
    return useContext(skuPropertiesFilterContext);
};

export const useEwaybillAccountStore = () => {
    return useContext(storeContext).ewaybillAccountStore;
};

export const useCompanySettingStore = () => {
    return useContext(companySettingStoreContext);
};
